import Conditional from '@app/components/common/Conditional';
import Espot from '@app/components/common/Espot/Espot';
import { getEspotImpressionOrClickEvent } from '@app/components/common/analytics/analyticsUtils';
import { useMyAccountLinks } from '@app/components/pages/account/hooks';
import { USER_TYPE_GUEST } from '@app/constants/commonConstants';
import { useEspot } from '@app/hooks';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import { useTracking } from 'react-tracking';
import { ESPOT_NAME, PROMO_CLICK } from './constants';
import styles from './styles.module.scss';

const ShoppingPreferencesEspot = () => {
  const { trackEvent } = useTracking();
  const clearEcommerce = { ecommerce: null };
  const { staticLinks } = useMyAccountLinks();
  const { isEspotLoading, getEspotContent } = useEspot(ESPOT_NAME);

  const locale = useSelector(s => s?.common?.locale);
  const shoppingPreferencesEspot = getEspotContent(ESPOT_NAME);
  const userType = useSelector(s => s?.common?.userType);
  const isLoggedIn = userType !== USER_TYPE_GUEST;

  const { url } = staticLinks.SHOPPING_PREFERENCES;

  const trackPromotionClickEvent = () => {
    const { dataset } =
      document.querySelector(`[data-name="${ESPOT_NAME}"]`) || {};

    if (!dataset) {
      return;
    }

    const { creative, id: range, name, position, type } = dataset;

    const htmlContent = {
      range,
      name,
      creative,
      source: ''
    };

    const promotionEvent = getEspotImpressionOrClickEvent(
      htmlContent,
      locale,
      type,
      position,
      PROMO_CLICK
    );
    trackEvent(clearEcommerce);
    trackEvent(promotionEvent);
  };

  return (
    <Conditional test={isLoggedIn}>
      <div
        className={cx(
          'container d-print-none py-5 espot__mobile-padding-bottom espot__mobile-padding-top',
          styles['summary-and-payment-espot__container']
        )}
      >
        <a
          className="text-decoration-none"
          href={url}
          onClick={trackPromotionClickEvent}
        >
          <div className="position-relative">
            <Espot html={shoppingPreferencesEspot} isLoading={isEspotLoading} />
          </div>
        </a>
      </div>
    </Conditional>
  );
};

export default ShoppingPreferencesEspot;
